import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import ModelImagesPanel from "./ModelImagesPanel";

// Popup wrapper around ModelImagesPanel, used from the AR Models list page.
// The panel is only mounted while open, so it refetches fresh on each open.
const ModelImagesDialog = ({ open, onClose, modelId, modelName, onNotify }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={styles.title}>
        <Box>
          <Typography sx={styles.titleText}>Manage Photos</Typography>
          {modelName ? (
            <Typography sx={styles.subTitle}>{modelName}</Typography>
          ) : null}
        </Box>
        <IconButton onClick={onClose} aria-label="close" sx={{ color: "#5B6B52" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {open ? (
          <ModelImagesPanel
            modelId={modelId}
            onNotify={onNotify}
            showTitle={false}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default ModelImagesDialog;

const styles = {
  title: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 2,
    pb: 1.5,
  },
  titleText: { fontFamily: "GilroyBold", fontSize: 18, color: "#1F2A1A" },
  subTitle: {
    fontFamily: "GilroyMedium",
    fontSize: 13,
    color: "#7A8A72",
    mt: 0.25,
  },
};
